import { render, staticRenderFns } from "./ButtonClearFilters.vue?vue&type=template&id=7f4a5920&"
import script from "./ButtonClearFilters.vue?vue&type=script&lang=js&"
export * from "./ButtonClearFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f4a5920')) {
      api.createRecord('7f4a5920', component.options)
    } else {
      api.reload('7f4a5920', component.options)
    }
    module.hot.accept("./ButtonClearFilters.vue?vue&type=template&id=7f4a5920&", function () {
      api.rerender('7f4a5920', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/ButtonClearFilters.vue"
export default component.exports